export const oraclePhrases = [
  "Se você não comprar, o desconto é de 100%. Reflita.",
  "Parcelar é abraçar um boleto que não te ama de volta.",
"O Oráculo viu seu carrinho da Shopee e sentiu uma leve tontura.",
  "Dinheiro não traz felicidade, mas boleto pago traz uma paz... 🕊️",
  "O Oráculo calculou: esse café de R$ 8 todo dia paga uma viagem em 2030.",
  "Pare de olhar o extrato com um olho fechado. Encare a realidade!",
  "Sua fatura do cartão não é um desafio de 'quem gasta mais'.",
  "O Oráculo previu: se você fechar esse app agora e for gastar, eu vou saber.",
  "Um minuto de silêncio por todos os reais que você gastou em delivery semana passada.",
  "Você trabalha pelo dinheiro ou ele trabalha contra você? 🥊",
  "Respire fundo. A vontade de gastar passa, mas a dívida fica.",
  "Gastar dinheiro que você não tem, para impressionar gente que você não gosta... Sério?",
  "A paz financeira não tem preço, mas tem organização.",
  "Spoiler: O Oráculo viu o mês que vem e... prepare o lombo! 🌪️",
  "Se organizar direitinho, sobra até pro litrão (ou pro café chique).",
  "O boleto é o único que te persegue com dedicação total.",
  "O Oráculo avisa: Promoção de 50% em algo que você não precisa é 100% de prejuízo.",
  "Não deixe para amanhã o gasto que você pode evitar hoje.",
  "Você chamou de mimo. Seu extrato chamou de padrão.",
  "R$ 30 não quebra ninguém. Mas 30 vezes R$ 30 quebra.",
  "Seu saldo piscou… e já era.",
  "Você nem lembra do que comprou. Mas ainda tá pagando.",
  "Isso aqui parecia uma boa ideia… há 5 minutos.",
  "Seu bolso só queria paz. Você trouxe emoção.",
  "Mais um gasto invisível… até fechar a fatura.",
  "Você não gastou muito. Só gastou sempre.",
  "Se repetir muito, vira problema profissional.",
  "Você não precisa de mais uma coisa. Precisa de um plano.",
  "O problema não é hoje. É o conjunto da obra.",
  "Você abriu o app ‘só pra ver’. Clássico.",
  "Dinheiro gosta de quem presta atenção nele.",
  "Controle financeiro não é sobre cortar tudo. É sobre parar de fingir.",
  "Seu cartão confia em você. Talvez demais.",
  "O extrato não mente. Só entrega.",
  "Você pode até esquecer esse gasto. A fatura não.",
  "Isso aqui não é azar. É padrão.",
  "Organizar dinheiro é tipo academia: você evita… até precisar.",
  "Como pode R$ 30 virar R$ 2000? O Brasil quer saber.",
  "Seu saldo foi de base.",
  "Você não caiu. Você foi com vontade.",
  "Aqui jaz o orçamento do mês. Viveu pouco, mas intensamente.",
  "Seu dinheiro sumiu… mas foi você que ajudou.",
  "Isso aqui não é compra. É conteúdo.",
  "Você quis viver perigosamente.",
  "Seu extrato vai render mais que série.",
  "Isso aqui era evitável. E mesmo assim aconteceu.",
  "Parabéns, você desbloqueou o modo ‘cadê meu dinheiro?’",

  // --- EDUCATIVO COM HUMOR ---
  "Se você precisa parcelar muito, talvez não seja pra agora.",
  "Dinheiro sem plano vira lembrança.",
  "Quem não controla, reage.",
  "Gastar bem é melhor que gastar menos.",
  "Organização hoje = paz amanhã.",
  "Nem todo desejo precisa virar compra.",
  "Se você não sabe pra onde foi, ele vai de novo.",
  "Planejamento é liberdade disfarçada.",
  "Seu dinheiro também precisa de direção.",
  "Você não precisa ganhar mais pra melhorar. Às vezes é só organizar."
];